import { render, staticRenderFns } from "./salesProjectDetail.vue?vue&type=template&id=a9aa6846"
import script from "./salesProjectDetail.vue?vue&type=script&lang=js"
export * from "./salesProjectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports